import React from 'react'

export default function RequiredMark(label: React.ReactNode, { required }: { required: boolean }) {
  return (
    <div className="md:whitespace-nowrap">
      {label}
      {required ? <span className="text-red-500">*</span> : null}
    </div>
  )
}
